import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('kdp_lang') || 'fr');

  useEffect(() => {
    localStorage.setItem('kdp_lang', lang);
    // RTL pour l'arabe
    document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', lang);
  }, [lang]);

  const toggleLang = () => setLang(l => l === 'fr' ? 'ar' : 'fr');

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, isRTL: lang === 'ar' }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}

// Bouton langue réutilisable
export function LangToggle({ style }) {
  const { lang, toggleLang } = useLang();
  return (
    <button
      onClick={toggleLang}
      style={{
        background: 'rgba(255,255,255,0.15)',
        border: 'none',
        borderRadius: 8,
        color: '#fff',
        fontSize: 12,
        fontWeight: 700,
        padding: '5px 10px',
        cursor: 'pointer',
        letterSpacing: 0.5,
        ...style,
      }}
      title={lang === 'fr' ? 'Passer en Arabe' : 'التحويل للفرنسية'}
    >
      {lang === 'fr' ? '🇩🇿 AR' : '🇫🇷 FR'}
    </button>
  );
}
